module.exports = __webpack_public_path__ + "img/product_90.2580bf6.webp";